<template>
  <div>
    <Section>
      <SectionHeader :title="$t('apps.payroll.message.type')"/>
      <FormRow>
        <Col className="col-lg-6">
        <BaseRadioRich
          v-model="input.type"
          :val="PAYSLIP_CONDITION_TYPE.BASIC"
          :label="$t('apps.payroll.message.radiotypebasic')"
          :message="$t('apps.payroll.message.radiotypebasicdetail')"
          :disabled="disabled || !!state"
        />
        </Col>
        <Col className="col-lg-6">
        <BaseRadioRich
          v-model="input.type"
          :val="PAYSLIP_CONDITION_TYPE.ADVANCED"
          :label="$t('apps.payroll.message.radiotypeadvanced')"
          :message="$t('apps.payroll.message.radiotypeadvanceddetail')"
          :disabled="disabled || !!state"
        />
        </Col>
      </FormRow>
    </Section>

    <Section>
      <SectionHeader :title="$t('apps.payroll.message.general')"/>
      <FormRow>
        <Col className="col-lg-6">
        <Label :text="`${$t('apps.payroll.message.name')} *`" />
        <BaseInput
          v-model="$v.input.name.$model"
          :classNames="[{ 'is-invalid': $v.input.name.$error }]"
          :disabled="disabled"
        />
        </Col>
      </FormRow>
      <FormRow>
        <Col className="col-lg-2">
        <Label :text="`${$t('apps.payroll.message.calculationtype')} *`" />
        <BaseDropdown
          v-model="$v.input.isIncrement.$model"
          :classNames="[{ 'is-invalid': $v.input.isIncrement.$error }]"
          :options="calcOptions"
          :disabled="disabled"
        />
        </Col>
      </FormRow>
    </Section>

    <Section
      v-if="input.type === PAYSLIP_CONDITION_TYPE.ADVANCED"
      class="mb-4">
      <SectionHeader :title="$t('apps.payroll.message.condition')"/>
      <FormRow>
        <Col className="col-lg-12">
        <BasePayrollCondition
          v-model="input.condition"
          :disabled="disabled"
          :valid.sync="isConditionValid"
          :validateFormValue.sync="validateFormValue"
          :validateFormIftrue.sync="validateFormIFTrue"
          :validateFormIfFalse.sync="validateFormIfFalse"
          :clearFormIfTrue.sync="clearFormIfTrue"
          :clearFormIfFalse.sync="clearFormIfFalse"
        />
        </Col>
      </FormRow>
    </Section>

    <Section className="mt-3">
      <FormRow>
        <Col className="col-lg-12">
        <BaseCheckbox
          v-model="input.autoApplyNewEmp"
          :label="$t('apps.payroll.label.autoapply')"
          :disabled="disabled"
        />
        </Col>
      </FormRow>
    </Section>

    <BaseFormAction
      v-if="showActionButtons"
      :textCancel="$t('button.cancel')"
      :textSubmit="$t('button.save')"
      :isSubmitted="isSubmitted"
      @onCancel="handleCancel"
      @onSubmit="handleSubmit"
    />
  </div>
</template>

<script>
import { required } from 'vuelidate/lib/validators'
import { PAYSLIP_CONDITION_TYPE, PAYROLL_CONDITION_VARIABLE, PAYROLL_CONDITION_OPERATOR } from '@/helpers/enum'
import _ from 'lodash'

export default {
  props: ['state', 'isSubmitted', 'disabled', 'employees', 'showActionButtons'],

  data () {
    return {
      PAYSLIP_CONDITION_TYPE,
      input: {
        type: PAYSLIP_CONDITION_TYPE.BASIC,
        name: null,
        isIncrement: null,
        condition: {
          variable: PAYROLL_CONDITION_VARIABLE.WAGES,
          operator: PAYROLL_CONDITION_OPERATOR.GREATER_THAN,
          value: null,
          iftrue: null,
          iffalse: null,
        },
        autoApplyNewEmp: false,
      },
      inputOriginal: null,
      isConditionValid: null,

      // sync functions
      validateFormValue: null,
      validateFormIFTrue: null,
      validateFormIfFalse: null,
      clearFormIfTrue: null,
      clearFormIfFalse: null,
    }
  },

  validations: {
    input: {
      name: {
        required,
      },
      isIncrement: {
        required,
      },
    },
  },

  computed: {
    defaultOption () {
      return {
        text: this.$t('placeholder.select'),
        value: null,
      }
    },
    calcOptions () {
      return [
        { ...this.defaultOption },
        { text: this.$t('apps.payroll.message.increment'), value: true },
        { text: this.$t('apps.payroll.message.decrement'), value: false },
      ]
    },
  },

  watch: {
    input: {
      handler: function () {
        this.$emit('update:form', this.input)
      },
      deep: true,
    },
  },

  created () {
    if (this.state) {
      this.setInput(this.state)
    } else {
      this.inputOriginal = _.cloneDeep(this.input)
    }
  },

  methods: {
    handleCancel () {
      if (this.$listeners.onCancel) {
        this.$emit('onCancel')
      } else {
        this.input = _.cloneDeep(this.inputOriginal)
        this.clearFormIfTrue()
        this.clearFormIfFalse()
        this.scrollToTop(600)
      }
    },
    handleSubmit () {
      this.$v.$touch()
      if (this.input.type === PAYSLIP_CONDITION_TYPE.ADVANCED) {
        this.validateFormValue()
        this.validateFormIFTrue()
        this.validateFormIfFalse()
      }
      if (this.$v.$invalid || (this.input.type === PAYSLIP_CONDITION_TYPE.ADVANCED && !this.isConditionValid)) {
        this.scrollToTop(600)
      } else {
        this.$emit('onSubmit', this.input)
      }
    },
    setInput (state) {
      this.input.type = state.type
      this.input.name = state.name
      this.input.isIncrement = state.isIncrement
      if (state.condition) {
        this.input.condition.variable = state.condition.variable
        this.input.condition.operator = state.condition.operator
        this.input.condition.value = state.condition.value
        this.input.condition.iftrue = state.condition.iftrue
        this.input.condition.iffalse = state.condition.iffalse
      }
      this.input.autoApplyNewEmp = state.autoApplyNewEmp
      this.inputOriginal = _.cloneDeep(this.input)
    },
  },
}
</script>



// WEBPACK FOOTER //
// src/components/combine/PayrollConditionForm.vue